<template>
  <div v-if="is_customer_logged_in">
    <div class="container orders-going">
      <loader v-show="processInProgress(process)" />
      <div
        class="email-slider"
        v-if="
          customer &&
            customer.item &&
            !customer.item.email_verified &&
            varification_email_banner
        "
      >
        {{ _T('Your email is not verified,') }} &nbsp;
        <button
          role="button"
          class="btn verify-email"
          @click.prevent="verifyEmail"
        >
          {{ _T('click here') }}
        </button>
        {{ _T('to verify') }}
      </div>
      <div
        class="email-slider"
        v-if="show_email_sent_status"
        v-html="show_email_sent_status"
      ></div>
      <div class="row account-menu" :class="{ 'profile-order': profileMobile }">
        <div class="col-lg-3 col-md-4 temporary">
          <div class="menu-left">
            <div class="menu-title">
              <h4 class="account-menu-toggle" @click="openprofilemenu()">
                {{ _T('My Account') }}
                <span class="float-right">
                  <img src="/images/svg/global/down.svg" />
                </span>
              </h4>
            </div>
            <ul :class="{ show: openprofileMenu }">
              <li :class="{ active: $route.name === 'profile.personal-info' }">
                <router-link :to="{ name: 'profile.personal-info' }">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.46447 15.4645C5.40215 14.5268 6.67392 14 8 14H16C17.3261 14 18.5979 14.5268 19.5355 15.4645C20.4732 16.4021 21 17.6739 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 18.2044 18.6839 17.4413 18.1213 16.8787C17.5587 16.3161 16.7956 16 16 16H8C7.20435 16 6.44129 16.3161 5.87868 16.8787C5.31607 17.4413 5 18.2044 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 17.6739 3.52678 16.4021 4.46447 15.4645Z"
                      fill="black"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7Z"
                      fill="black"
                    ></path>
                  </svg>
                  <h4>{{ _T('Change Profile') }}</h4>
                </router-link>
              </li>
              <li
                :class="{
                  active:
                    $route.name === 'profile.ongoing-orders' ||
                    $route.name === 'profile.scheduled-orders' ||
                    $route.name === 'profile.order',
                }"
              >
                <router-link :to="{ name: 'profile.ongoing-orders' }"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.12 6.71L17.29 3.88C16.7279 3.31723 15.9654 3.0007 15.17 3H8.83C8.03462 3.0007 7.27207 3.31723 6.71 3.88L3.88 6.71C3.31723 7.27207 3.0007 8.03462 3 8.83V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V8.83C20.9993 8.03462 20.6828 7.27207 20.12 6.71ZM8.12 5.29C8.31163 5.10727 8.56523 5.00368 8.83 5H15.17C15.4348 5.00368 15.6884 5.10727 15.88 5.29L17.59 7H6.41L8.12 5.29ZM18 19H6C5.73478 19 5.48043 18.8946 5.29289 18.7071C5.10536 18.5196 5 18.2652 5 18V9H19V18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19Z"
                      fill="black"
                    ></path>
                    <path
                      d="M15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11Z"
                      fill="black"
                    ></path>
                  </svg>
                  <h4>{{ _T('My Orders') }}</h4>
                </router-link>
              </li>
              <li :class="{ active: $route.name.includes('history') }">
                <router-link :to="{ name: 'profile.history' }"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C9.43639 2.00731 6.97349 2.99891 5.12 4.77V3C5.12 2.73478 5.01464 2.48043 4.82711 2.29289C4.63957 2.10536 4.38522 2 4.12 2C3.85478 2 3.60043 2.10536 3.41289 2.29289C3.22536 2.48043 3.12 2.73478 3.12 3V7.5C3.12 7.76522 3.22536 8.01957 3.41289 8.20711C3.60043 8.39464 3.85478 8.5 4.12 8.5H8.62C8.88522 8.5 9.13957 8.39464 9.32711 8.20711C9.51464 8.01957 9.62 7.76522 9.62 7.5C9.62 7.23478 9.51464 6.98043 9.32711 6.79289C9.13957 6.60536 8.88522 6.5 8.62 6.5H6.22C7.50578 5.15636 9.21951 4.30265 11.0665 4.08567C12.9136 3.86868 14.7785 4.30198 16.3407 5.31104C17.9028 6.32011 19.0646 7.84191 19.6263 9.61479C20.188 11.3877 20.1145 13.3009 19.4184 15.0254C18.7223 16.7499 17.4472 18.1781 15.8122 19.0643C14.1772 19.9505 12.2845 20.2394 10.4596 19.8813C8.63463 19.5232 6.99147 18.5405 5.81259 17.1022C4.63372 15.6638 3.99279 13.8597 4 12C4 11.7348 3.89464 11.4804 3.70711 11.2929C3.51957 11.1054 3.26522 11 3 11C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 13.9778 2.58649 15.9112 3.6853 17.5557C4.78412 19.2002 6.3459 20.4819 8.17317 21.2388C10.0004 21.9957 12.0111 22.1937 13.9509 21.8079C15.8907 21.422 17.6725 20.4696 19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8079 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17317C20.4819 6.3459 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2ZM12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13H14C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11H13V9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8Z"
                      fill="black"
                    ></path>
                  </svg>
                  <h4>{{ _T('History') }}</h4>
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'profile.addresses' }">
                <router-link :to="{ name: 'profile.addresses' }"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C9.43639 2.00731 6.97349 2.99891 5.12 4.77V3C5.12 2.73478 5.01464 2.48043 4.82711 2.29289C4.63957 2.10536 4.38522 2 4.12 2C3.85478 2 3.60043 2.10536 3.41289 2.29289C3.22536 2.48043 3.12 2.73478 3.12 3V7.5C3.12 7.76522 3.22536 8.01957 3.41289 8.20711C3.60043 8.39464 3.85478 8.5 4.12 8.5H8.62C8.88522 8.5 9.13957 8.39464 9.32711 8.20711C9.51464 8.01957 9.62 7.76522 9.62 7.5C9.62 7.23478 9.51464 6.98043 9.32711 6.79289C9.13957 6.60536 8.88522 6.5 8.62 6.5H6.22C7.50578 5.15636 9.21951 4.30265 11.0665 4.08567C12.9136 3.86868 14.7785 4.30198 16.3407 5.31104C17.9028 6.32011 19.0646 7.84191 19.6263 9.61479C20.188 11.3877 20.1145 13.3009 19.4184 15.0254C18.7223 16.7499 17.4472 18.1781 15.8122 19.0643C14.1772 19.9505 12.2845 20.2394 10.4596 19.8813C8.63463 19.5232 6.99147 18.5405 5.81259 17.1022C4.63372 15.6638 3.99279 13.8597 4 12C4 11.7348 3.89464 11.4804 3.70711 11.2929C3.51957 11.1054 3.26522 11 3 11C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 13.9778 2.58649 15.9112 3.6853 17.5557C4.78412 19.2002 6.3459 20.4819 8.17317 21.2388C10.0004 21.9957 12.0111 22.1937 13.9509 21.8079C15.8907 21.422 17.6725 20.4696 19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8079 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17317C20.4819 6.3459 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2ZM12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13H14C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11H13V9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8Z"
                      fill="black"
                    ></path>
                  </svg>
                  <h4>{{ _T('My Addresses') }}</h4>
                </router-link>
              </li>
              <li
                :class="{ active: $route.name === 'profile.wallet' }"
                v-if="isModuleEnable('Loyalty')"
              >
                <router-link :to="{ name: 'profile.wallet' }"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 7H18V6C18 5.20435 17.6839 4.44129 17.1213 3.87868C16.5587 3.31607 15.7956 3 15 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V18C2 18.7956 2.31607 19.5587 2.87868 20.1213C3.44129 20.6839 4.20435 21 5 21H19C19.7956 21 20.5587 20.6839 21.1213 20.1213C21.6839 19.5587 22 18.7956 22 18V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7ZM5 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM20 15H19C18.7348 15 18.4804 14.8946 18.2929 14.7071C18.1054 14.5196 18 14.2652 18 14C18 13.7348 18.1054 13.4804 18.2929 13.2929C18.4804 13.1054 18.7348 13 19 13H20V15ZM20 11H19C18.2044 11 17.4413 11.3161 16.8787 11.8787C16.3161 12.4413 16 13.2044 16 14C16 14.7956 16.3161 15.5587 16.8787 16.1213C17.4413 16.6839 18.2044 17 19 17H20V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V8.83C4.32127 8.94302 4.65943 9.00051 5 9H19C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10V11Z"
                      fill="black"
                    ></path>
                  </svg>

                  <h4>{{ _T('My Cashback') }}</h4>
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'profile.saved-cards' }">
                <router-link :to="{ name: 'profile.saved-cards' }"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.6956 4.97949H4.80178C3.52517 4.97949 2.49707 6.00759 2.49707 7.2842V17.2137C2.49707 18.4903 3.52517 19.5184 4.80178 19.5184H19.6956C20.9722 19.5184 22.0003 18.4903 22.0003 17.2137V7.28505C22.0003 6.00844 20.9722 4.97949 19.6956 4.97949ZM4.26986 11.7174H20.2275V17.2137C20.2275 17.4971 19.979 17.7456 19.6956 17.7456H4.80178C4.51837 17.7456 4.26986 17.4971 4.26986 17.2137V11.7174ZM4.80178 6.75313H19.6956C19.979 6.75313 20.2275 7.00164 20.2275 7.28505V8.88081H4.26986V7.28505C4.26986 7.00081 4.51837 6.75313 4.80178 6.75313Z"
                      fill="#3D3F43"
                    ></path>
                    <path
                      d="M6.32774 16.6816H8.81032C9.30649 16.6816 9.69714 16.2918 9.69714 15.7948V13.6671C9.69714 13.1709 9.30734 12.7803 8.81032 12.7803H6.32774C5.83156 12.7803 5.44092 13.1701 5.44092 13.6671V15.7948C5.44092 16.2918 5.83071 16.6816 6.32774 16.6816Z"
                      fill="#3D3F43"
                    ></path>
                  </svg>
                  <h4>{{ _T('Saved Card') }}</h4>
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'profile.notifications' }">
                <router-link :to="{ name: 'profile.notifications' }"
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 13.18V10C17.9986 8.58312 17.4958 7.21247 16.5806 6.13077C15.6655 5.04908 14.3971 4.32615 13 4.09V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V4.09C9.60294 4.32615 8.33452 5.04908 7.41939 6.13077C6.50425 7.21247 6.00144 8.58312 6 10V13.18C5.41645 13.3863 4.911 13.7681 4.55294 14.2729C4.19488 14.7778 4.00174 15.3811 4 16V18C4 18.2652 4.10536 18.5196 4.29289 18.7071C4.48043 18.8946 4.73478 19 5 19H8.14C8.37028 19.8474 8.873 20.5954 9.5706 21.1287C10.2682 21.6621 11.1219 21.951 12 21.951C12.8781 21.951 13.7318 21.6621 14.4294 21.1287C15.127 20.5954 15.6297 19.8474 15.86 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18V16C19.9983 15.3811 19.8051 14.7778 19.4471 14.2729C19.089 13.7681 18.5835 13.3863 18 13.18ZM8 10C8 8.93913 8.42143 7.92172 9.17157 7.17157C9.92172 6.42143 10.9391 6 12 6C13.0609 6 14.0783 6.42143 14.8284 7.17157C15.5786 7.92172 16 8.93913 16 10V13H8V10ZM12 20C11.651 19.9979 11.3086 19.9045 11.0068 19.7291C10.7051 19.5536 10.4545 19.3023 10.28 19H13.72C13.5455 19.3023 13.2949 19.5536 12.9932 19.7291C12.6914 19.9045 12.349 19.9979 12 20ZM18 17H6V16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15H17C17.2652 15 17.5196 15.1054 17.7071 15.2929C17.8946 15.4804 18 15.7348 18 16V17Z"
                      fill="black"
                    ></path>
                  </svg>
                  <h4>{{ _T('Notifications') }}</h4>
                </router-link>
              </li>
              <!-- <li>
              <router-link :to="{ name: 'profile.help' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.031 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.7411 9.25718 8.87418C9.23529 9.00726 9.24055 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52854 9.44389 9.63643C9.52481 9.74433 9.62671 9.83475 9.74348 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.3474 11.345 9.22078 11.4978 9.13298C11.6505 9.04518 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71352C13.3828 7.25801 12.7035 7.00546 12 7Z"
                    fill="black"
                  ></path>
                </svg>
                <h4>{{ _T('Help') }}</h4>
              </router-link>
            </li> -->

              <li @click="$bvModal.show('log-out')">
                <a>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.41 10.9999L13.71 8.7099C13.8037 8.61694 13.8781 8.50634 13.9289 8.38448C13.9797 8.26262 14.0058 8.13191 14.0058 7.9999C14.0058 7.86789 13.9797 7.73718 13.9289 7.61532C13.8781 7.49346 13.8037 7.38286 13.71 7.2899C13.617 7.19617 13.5064 7.12178 13.3846 7.07101C13.2627 7.02024 13.132 6.9941 13 6.9941C12.868 6.9941 12.7373 7.02024 12.6154 7.07101C12.4936 7.12178 12.383 7.19617 12.29 7.2899L8.29 11.2899C8.19896 11.385 8.12759 11.4971 8.08 11.6199C7.97998 11.8634 7.97998 12.1364 8.08 12.3799C8.12759 12.5027 8.19896 12.6148 8.29 12.7099L12.29 16.7099C12.3832 16.8031 12.4939 16.8771 12.6158 16.9276C12.7376 16.978 12.8681 17.004 13 17.004C13.1319 17.004 13.2624 16.978 13.3843 16.9276C13.5061 16.8771 13.6168 16.8031 13.71 16.7099C13.8032 16.6167 13.8772 16.506 13.9277 16.3841C13.9781 16.2623 14.0041 16.1318 14.0041 15.9999C14.0041 15.868 13.9781 15.7375 13.9277 15.6156C13.8772 15.4938 13.8032 15.3831 13.71 15.2899L11.41 12.9999L21 12.9999C21.2652 12.9999 21.5196 12.8945 21.7071 12.707C21.8946 12.5195 22 12.2651 22 11.9999C22 11.7347 21.8946 11.4803 21.7071 11.2928C21.5196 11.1053 21.2652 10.9999 21 10.9999L11.41 10.9999ZM12 21.9999C13.8689 22.0082 15.7028 21.4927 17.2935 20.5117C18.8843 19.5307 20.1683 18.1236 21 16.4499C21.1193 16.2112 21.139 15.9349 21.0546 15.6817C20.9702 15.4285 20.7887 15.2192 20.55 15.0999C20.3113 14.9806 20.035 14.9609 19.7818 15.0453C19.5286 15.1297 19.3193 15.3112 19.2 15.5499C18.5678 16.8266 17.6062 17.9113 16.4145 18.6919C15.2227 19.4725 13.8442 19.9208 12.4212 19.9903C10.9983 20.0598 9.58262 19.7481 8.32048 19.0874C7.05834 18.4267 5.99553 17.4409 5.24189 16.2319C4.48825 15.0229 4.07112 13.6347 4.0336 12.2105C3.99608 10.7864 4.33954 9.37806 5.02849 8.13109C5.71743 6.88412 6.72686 5.84374 7.95246 5.11747C9.17807 4.3912 10.5754 4.00539 12 3.9999C13.4911 3.99344 14.9538 4.40753 16.2203 5.19465C17.4868 5.98177 18.5056 7.11001 19.16 8.4499C19.2793 8.68859 19.4886 8.8701 19.7418 8.95449C19.995 9.03888 20.2713 9.01925 20.51 8.8999C20.7487 8.78055 20.9302 8.57127 21.0146 8.3181C21.099 8.06492 21.0793 7.78859 20.96 7.5499C20.1672 5.95439 18.9625 4.59967 17.4705 3.62585C15.9786 2.65204 14.2536 2.0945 12.4739 2.01091C10.6942 1.92732 8.92452 2.32071 7.34786 3.15039C5.7712 3.98007 4.44482 5.21591 3.50593 6.73008C2.56704 8.24425 2.04973 9.98176 2.0075 11.7629C1.96528 13.544 2.39967 15.3041 3.26576 16.8611C4.13184 18.418 5.39816 19.7153 6.93373 20.6188C8.4693 21.5223 10.2184 21.9991 12 21.9999Z"
                      fill="black"
                    ></path>
                  </svg>
                  <h4>{{ _T('Logout') }}</h4>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 sub-component">
          <router-view />
        </div>
      </div>
    </div>
    <MobileChangeProfile v-if="profileMobile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MobileChangeProfile from './MobileProfileMenu/MobileChangeProfile'
import Loader from '@/components/Elements/Loader.vue'

export default {
  name: 'Profile',
  data() {
    return {
      openprofileMenu: false,
      profilemobile: ['profile.personal-info'],
      process: 'load-order',
      show_email_confirm: null,
      show_email_sent_status: null,
    }
  },
  components: {
    MobileChangeProfile,
    Loader,
  },
  computed: {
    ...mapGetters([
      '_T',
      'customer',
      'all_customer_orders',
      'processInProgress',
      'varification_email_banner',
      'is_customer_logged_in',
      'availableModules',
      'isModuleEnable',
    ]),
    profileMobile() {
      if (
        this.$route.matched.some(({ name }) =>
          this.profilemobile.includes(name)
        )
      ) {
        return true
      }
      return false
    },
  },
  methods: {
    openprofilemenu() {
      this.openprofileMenu = !this.openprofileMenu
    },
    verifyEmail() {
      var that = this
      this.$store.commit('SET_EMAIL_BANNNER', false)
      this.show_email_sent_status = this._T('Sending Email...')
      this.$store
        .dispatch('sendOTP', {
          mode: 'email',
          reference: that.customer.item.email,
        })
        .then(res => {
          if (res.data.status == 'form_errors') {
            this.show_email_sent_status = this._T(res.data.form_errors.email[0])
          } else {
            that.$store
              .dispatch('showNotification', {
                text: that._T('Email has been sent successfully'),
                status: 'success',
              })
              .then(() => {
                this.show_email_sent_status = null
              })
          }
        })
    },
  },
  mounted() {
    /*this.$store.dispatch('startProcess', {
      process: this.process,
      progress: true,
    })
    this.$store.dispatch('load_orders')
    this.$store
      .dispatch('load_customer')
      .then(() => {})
      .finally(() => {
        this.$store.dispatch('stopProcess', this.process)
      })
    this.$store.commit('SET_EMAIL_BANNNER', !this.customer.item.email_verified)*/
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .menu-left {
      margin-bottom: $px90;
      ul {
        padding-left: unset;
        padding-right: 0;
        li {
          text-align: right;
          a {
            h4 {
              padding-left: unset;
              padding-right: 0.375rem;
            }
          }
        }
      }
      .menu-title {
        .account-menu-toggle {
          text-align: right;
        }
      }
    }
  }
}
.orders-going {
  margin-bottom: $px90;
  @media (max-width: 575px) {
    margin-bottom: 0;
  }
  .email-slider {
    background-color: $warning-color-background;
    display: flex;
    align-content: center;
    align-items: center;
    align-self: center;
    justify-content: center;
    .verify-email {
      color: $primary-color;
      padding: $px10 $px5;
      font-weight: 600;
    }
  }
}
.account-menu {
  padding-top: $px40;
  .account-right {
    .account-card {
      margin-top: 0;
      box-shadow: none;
      border-radius: 0;
    }
  }
  .menu-left {
    margin-bottom: $px90;
    .menu-title {
      h4 {
        margin-bottom: calc(
          #{$px30} + (68 - 30) * ((100vw - #{$px320}) / (1920 - 320))
        );
        font-size: calc(
          #{$px16} + (20 - 16) * ((100vw - #{$px320}) / (1920 - 320))
        );
        line-height: $px24;
        color: $font-color;
        font-weight: 600;
        span {
          display: none;
        }
      }
    }
    ul {
      li {
        display: block;
        &.active {
          a {
            svg {
              fill: $color-primary !important;
              path {
                fill: $color-primary !important;
              }
            }
            h4 {
              color: $color-primary;
            }
          }
        }
        &.active {
          .steps {
            border-color: $color-primary;
            svg {
              fill: $color-primary !important;
              path {
                fill: $color-primary !important;
              }
            }
            h4 {
              color: $font-color;
            }
            &::before {
              border-top: $px2 solid $color-primary;
            }
          }
        }
        a {
          svg {
            vertical-align: bottom;
          }
          h4 {
            display: inline-block;
            margin-bottom: 0;
            padding-left: $px6;
            color: $font-color;
            position: relative;
            .dot-notify {
              width: $px6;
              height: $px6;
              background-color: $color-primary;
              border-radius: 100%;
              position: absolute;
              top: 0;
              right: -$px12;
            }
          }
        }
        + li {
          margin-top: calc(
            #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .account-menu {
    .menu-left {
      margin-bottom: $px90;
      position: relative;
      .menu-title {
        h4 {
          span {
            display: block;
          }
        }
      }
      ul {
        opacity: 0;
        visibility: hidden;
        position: absolute;
        top: $px30;
        left: 0;
        background-color: white;
        width: 100%;
        border-radius: $px4;
        border: $px1 solid $light-border;
        padding: $px20 $px16;
        box-shadow: 0px $px14 $px34 rgba($black, 0.1);
        transition: all 0.5s ease;
        max-height: $px220;
        overflow: auto;
        z-index: 1;
        &.show {
          opacity: 1;
          visibility: visible;
          top: $px35;
          transition: all 0.5s ease;
        }
      }
    }
  }
  .fixed-mp-cls {
    margin-bottom: $px60;
  }
}
.body-rtl {
  //@media (max-width: 575px) {
    .sub-component {
      text-align: right;
    }
  //}
}
@media (max-width: 575px) {
  .profile-order {
    display: none;
  }
  .orders-going,
  .saved-card {
    .account-menu {
      padding-top: 0;
      > div {
        padding: 0;
      }
    }
    .menu-left {
      display: none;
    }
  }
}
</style>
